export default __webpack_public_path__ + "static/media/bhxh-cover.24dc26a2.jpg";